
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import type { SelectOptions } from 'shared/types'
import { normalizeSelectOptions } from 'shared/util'

@Component
export default class SelectControl extends Vue {

	@Prop() label?: string
	@Prop() name!: string
	@Prop({ type: [Array, Object] }) options!: SelectOptions
	@Prop() value!: string

	get selectOptions() {
		return normalizeSelectOptions(this.options)
	}

}
